import React from 'react'
import { connect } from 'react-redux'
import { compose, lifecycle, withState } from 'recompose'
import {
  reduxForm,
  getFormValues,
  Field,
  reset,
  SubmissionError,
} from 'redux-form'
import { Confirm, Modal, Button, Header, Checkbox } from 'semantic-ui-react'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { Cont, ModalAction } from './styled'
import {
  createPermissionRole,
  updatePermissionRole,
  deletePermissionRole,
  fetchPermissions,
} from 'ducks/roleMan'

import { Toaster } from '@blueprintjs/core'
let toast = Toaster.create({ message: '', show: false })

const FormPermissionRoleModal = props => {
  const {
    handleSubmit,
    data,
    valueForm,
    show,
    title,
    changeShow,
    showConfirm,
    setShowConfirm,
  } = props

  return (
    <div>
      <Modal
        size="tiny"
        open={show}
        closeOnEscape={false}
        closeOnDimmerClick={false}
        onMount={() => onModalMount()}
      >
        <Modal.Header>{title || ''}</Modal.Header>
        <Modal.Content>
          <form onSubmit={handleSubmit(() => submitValidate(props.valueForm))}>
            <Cont>
              {!props.isCreate ? (
                <div className="subCont">
                  <Header as="h3">{`Permission Name : ${valueForm &&
                    valueForm.name}`}</Header>
                </div>
              ) : (
                <Field
                  name="permissionId"
                  label="Permission"
                  options={props.permissions}
                  type={type.select}
                  component={FieldInput}
                  require
                  placeHolder={'Select Permission'}
                />
              )}
              <div style={{ height: '1rem' }} />
              <div className="subCont ui form">
                <Field
                  name="allowView"
                  label="Allow View"
                  type={type.checkbox}
                  component={FieldInput}
                />
                <Field
                  name="allowCreate"
                  label="Allow Create"
                  type={type.checkbox}
                  component={FieldInput}
                />
                <Field
                  name="allowEdit"
                  label="Allow Edit"
                  type={type.checkbox}
                  component={FieldInput}
                />
                <Field
                  name="allowDelete"
                  label="Allow Delete"
                  type={type.checkbox}
                  component={FieldInput}
                />
              </div>
            </Cont>
            <ModalAction>
              {!props.isCreate && (
                <Button
                  onClick={() => props.setIsDelete(true)}
                  type="submit"
                  negative
                >
                  Delete
                </Button>
              )}
              <Button onClick={() => closeModal()} negative>
                Cancel
              </Button>
              <Button
                onClick={() => props.setIsDelete(false)}
                type="submit"
                positive
                labelPosition="right"
                icon="save"
                content="Save"
              />
            </ModalAction>
          </form>
        </Modal.Content>
      </Modal>
      <Confirm
        size="mini"
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => submitModal()}
      />
    </div>
  )

  function submitValidate(values) {
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))
    return sleep(100).then(() => {
      if (props.isCreate && values.permissionId === 0) {
        throw new SubmissionError({ permissionId: 'Required!' })
      }
      setShowConfirm(true)
    })
  }

  function submitModal() {
    setShowConfirm(false)
    if (props.isCreate) {
      let role = props.roles.find(item => item.id === props.roleId)
      let hasRole = role.permission.find(
        item => item.permissionId === valueForm.permissionId
      )
      if (hasRole) {
        toast.clear()
        toast.show({
          message: hasRole.name + ' was already',
          intent: 'warning',
          timeout: 10000,
        })
        closeModal()
      } else {
        props.createPermissionRole(
          {
            roleId: props.roleId,
            permissionId: valueForm.permissionId,
            allowCreate: valueForm.allowCreate,
            allowEdit: valueForm.allowEdit,
            allowDelete: valueForm.allowDelete,
            allowView: valueForm.allowView,
          },
          closeModal
        )
      }
    } else if (props.isDelete) {
      props.deletePermissionRole(
        {
          id: data.id,
          roleId: data.roleId,
          permissionId: data.permissionId,
        },
        closeModal
      )
    } else {
      props.updatePermissionRole(
        {
          id: data.id,
          roleId: data.roleId,
          allowCreate: valueForm.allowCreate,
          allowEdit: valueForm.allowEdit,
          allowDelete: valueForm.allowDelete,
          allowView: valueForm.allowView,
        },
        closeModal
      )
    }
  }

  function closeModal() {
    changeShow()
    props.dispatch(reset('formPermissionRoleModal'))
  }

  function onModalMount() {
    props.fetchPermissions()
  }
}

const validate = values => {
  const errors = {}
  if (!values.name) {
    errors.name = 'Required!'
  }
  if (!values.description) {
    errors.description = 'Required!'
  }
  if (!values.permissionId) {
    errors.permissionId = 'Required!'
  }
  return errors
}

const mapStateToProps = (state, props) => {
  return {
    initialValues: {
      name: props.data ? props.data.name : '',
      allowView: props.data ? props.data.allowView : false,
      allowCreate: props.data ? props.data.allowCreate : false,
      allowEdit: props.data ? props.data.allowEdit : false,
      allowDelete: props.data ? props.data.allowDelete : false,
    },
    valueForm: getFormValues('formPermissionRoleModal')(state),
    permissions: state.roleMan.permissions
      ? state.roleMan.permissions.map(item => ({
          value: item.id,
          text: item.name,
        }))
      : [],
    roles: state.roleMan.roles,
  }
}

const mapDispatchToProps = {
  createPermissionRole,
  updatePermissionRole,
  deletePermissionRole,
  fetchPermissions,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'formPermissionRoleModal',
    validate: validate,
    enableReinitialize: true,
  }),
  withState('showConfirm', 'setShowConfirm', false),
  withState('isDelete', 'setIsDelete', false),
  lifecycle({
    componentDidMount() {},
    componentWillReceiveProps(nextProp) {},
  })
)

export default enhance(FormPermissionRoleModal)
